import { Button } from '@getro/rombo';
import { Check } from 'lucide-react';
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Image, Text } from 'rebass/styled-components';

import UserAvatarOne from '../../assets/claim-profile/user-avatar-1.png';
import Vector2 from '../../assets/lucide/vector2.svg';
import { trackEvent } from '../../helpers/analytics';

export const NoConnectHome = ({ networkName }) => (
  <Flex
    sx={{
      flexDirection: 'column',
      gap: '40px',
      alignItems: 'flex-start',
      maxWidth: '400px',
      width: '100%',
      mx: 'auto',
      mt: '64px',
    }}
  >
    <Flex sx={{ flexDirection: 'column', gap: '24px', alignItems: 'flex-start' }}>
      <Flex flexDirection="column" gap="8px">
        <Text
          sx={{
            color: 'text.subtle',
            fontSize: '15px',
            fontWeight: '400',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            display: 'flex',
            gap: '4px',
          }}
        >
          <Text>Introducing </Text>
          <Box as="span" color="purple.500" fontWeight="700" letterSpacing={0.5}>
            GetroConnect
          </Box>
        </Text>
        <Text color="text.dark" fontSize="28px" fontWeight="700">
          Get warm intros for {networkName}
        </Text>
      </Flex>
      <Text color="text.main" fontSize="18px" fontWeight="400">
        Your network is no longer just a list of names. Now it&apos;s a useful asset that helps generate leads, meet
        candidates, and get advice.
      </Text>
      <Flex sx={{ flexDirection: 'column', gap: '16px', color: 'text.dark', fontWeight: 500 }}>
        {[
          'Bring your extended network together',
          'Surface key contacts',
          'Get warm intros for sales, hiring, and more!',
        ].map((item) => (
          <Flex key={item} sx={{ flexDirection: 'row', gap: '8px' }}>
            <Box as={Check} size="16px" sx={{ color: 'purple.500' }} />
            <Text>{item}</Text>
          </Flex>
        ))}
      </Flex>
    </Flex>
    <Flex sx={{ flexDirection: 'column', gap: '64px', alignItems: 'center', width: '100%' }}>
      <Flex sx={{ flexDirection: 'column', gap: '8px', width: '100%' }}>
        <Text color="text.main" fontSize="14px" fontWeight="400" textAlign="center">
          Your investors already use Getro. Now you can, too.
        </Text>
        <Button
          as="a"
          href="https://www.getro.com/demo?utm_source=getro&utm_campaign=g4c&utm_content=create_network_cta"
          target="_blank"
          sx={{
            justifyContent: 'center',
            width: '100%',
          }}
          onClick={() => {
            trackEvent('upsell:getro_for_companies_demo_click', { origin: 'getro_connect_screen' });
          }}
        >
          Book a demo
        </Button>
      </Flex>

      <Flex sx={{ justifyContent: 'space-between', gap: '16px', width: '100%' }}>
        <Box sx={{ position: 'relative', width: '64px', height: '64px' }}>
          <Box
            sx={{
              backgroundImage: `url(${UserAvatarOne})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              width: '64px',
              height: '64px',
              borderRadius: '64px',
            }}
          />
          <Box
            sx={{
              background: 'linear-gradient(219deg, #702DFF 15.72%, #F4F 73.31%)',
              opacity: 0.7,
              mixBlendMode: 'lighten',
              width: '64px',
              height: '64px',
              borderRadius: '64px',
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          ></Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
          <Flex sx={{ position: 'relative', maxWidth: '346px' }}>
            <Box>
              <Image src={Vector2} sx={{ position: 'relative', top: '15px' }} />
            </Box>
            <Box
              sx={{
                borderRadius: '4px',
                bg: 'neutral.20',
                p: '8px',
                width: '320px',
                position: 'relative',
              }}
            >
              <Text fontSize="16px" fontWeight="400" color="text.dark">
                Thanks to Getro, we got warm intros to our sales targets. Even ones that Sales Navigator missed.
              </Text>
            </Box>
          </Flex>
          <Box ml="6px">
            <Text sx={{ color: 'text.dark', fontWeight: 600, fontSize: '14px' }}>Justo Varela</Text>
            <Text sx={{ color: 'text.subtle', fontWeight: 400, fontSize: '14px' }}>Growth Specialist at FlyFlat</Text>
          </Box>
        </Box>
      </Flex>
    </Flex>
  </Flex>
);

NoConnectHome.propTypes = {
  networkName: PropTypes.string.isRequired,
};

export default NoConnectHome;
